if (!customElements.get('ac-creative-hero')) {
  customElements.define('ac-creative-hero', class extends HTMLElement {
    connectedCallback() {
      this.abortController?.abort();
      this.abortController = new AbortController();
      const options = { signal: this.abortController.signal };
      this.slides = [...this.querySelectorAll('[data-campaign]')];
      this.buttons = [...this.querySelectorAll('button[aria-controls]')];
      this.pauseButton = this.querySelector('[data-pause]');
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.motion.matches || Boolean(window.Shopify?.designMode);
      this.hovered = false;
      this.buttons.forEach((button, index) => {
        button.addEventListener('click', () => { this.select(index); this.schedule(); }, options);
      });
      this.pauseButton?.addEventListener('click', () => {
        this.paused = !this.paused;
        this.updatePause();
        this.schedule();
      }, options);
      this.addEventListener('pointerenter', (event) => {
        if (event.pointerType === 'mouse') { this.hovered = true; this.schedule(); }
      }, options);
      this.addEventListener('pointerleave', () => { this.hovered = false; this.schedule(); }, options);
      this.addEventListener('focusin', () => this.schedule(), options);
      this.addEventListener('focusout', () => queueMicrotask(() => this.schedule()), options);
      document.addEventListener('visibilitychange', () => this.schedule(), options);
      this.motion.addEventListener('change', () => {
        this.paused = this.motion.matches;
        this.updatePause();
        this.schedule();
      }, options);
      this.addEventListener('shopify:block:select', (event) => {
        const index = this.slides.findIndex((slide) => slide === event.target || slide.contains(event.target));
        if (index >= 0) { this.paused = true; this.select(index); this.updatePause(); this.schedule(); }
      }, options);
      this.select(0);
      this.updatePause();
      const controls = this.querySelector('.ac-creative-hero__controls');
      if (controls) controls.hidden = false;
      this.schedule();
    }
    disconnectedCallback() {
      this.abortController?.abort();
      clearTimeout(this.timer);
    }
    updatePause() {
      if (!this.pauseButton) return;
      this.pauseButton.setAttribute('aria-label', this.paused ? this.pauseButton.dataset.playLabel : this.pauseButton.dataset.pauseLabel);
      this.pauseButton.firstElementChild.textContent = this.paused ? '▶' : 'Ⅱ';
    }
    schedule() {
      clearTimeout(this.timer);
      if (!this.isConnected || this.paused || this.hovered || document.hidden || this.contains(document.activeElement) || this.slides.length < 2) return;
      this.timer = setTimeout(() => {
        this.select((this.index + 1) % this.slides.length);
        this.schedule();
      }, Number(this.dataset.interval) || 7000);
    }
    select(index) {
      this.index = index;
      this.slides.forEach((slide, position) => { slide.hidden = position !== index; });
      this.buttons.forEach((button, position) => {
        button.setAttribute('aria-pressed', String(position === index));
      });
    }
  });
}
